import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteAwardNominationReviewer: (
  fetchContext: FetchContext,
  awardNominationReviewerId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardNominationReviewerId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/award-nomination-reviewers/${awardNominationReviewerId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete award nomination reviewer'));
